class contactFormCustom extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.handleCheckbox();
    }

    handleCheckbox() {
        const checkbox = this.querySelector('#ContactForm-checkbox');
        const submitButton = this.querySelector('#ContactForm-submit');

        if (checkbox && submitButton) {
            checkbox.addEventListener('change', () => {
                submitButton.disabled = !checkbox.checked;
            });
        } 
    }
}

customElements.define('contact-form-custom', contactFormCustom);
